
import { mapGetters, mapState } from 'vuex'
import utils from '@/components/tools/utils'
import LanguageSettingHeaderMenu from '@/components/account/data/LanguageSettingHeaderMenu.vue'

export default {
  name: 'AppBar',
  components: {
    LanguageSettingHeaderMenu,
    CatalogFilterDrawer: () => import('@/layouts/catalog-filter-drawer'),
    Cm24DropDownMenu: () => import('@/layouts/cm24-drop-down-menu'),
    Cm24NavigationDrawer: () => import('@/layouts/cm24-navigation-drawer')
  },
  props: {
    app: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      showSystemBar: false,
      loggedInKey: 1,
      notLoggedInKey: -1
    }
  },

  computed: {
    ...mapState('customer', ['isEditing', 'merchant', 'hasAnyAds']),
    ...mapGetters({ isAdmin: 'isUserAdmin' }),
    ...mapState('general', ['hideNavbar']),

    isMerchant () {
      return typeof this.merchant?.merchantId === 'number'
    },
    path () {
      return this.$route.path
    },

    hideNavbarOnThisPage () {
      if (this.path in this.hideNavbar) {
        return this.hideNavbar[this.path]
      } else {
        return false
      }
    },

    imgSrc () {
      if (this.isAdmin) {
        return 'logo-440px-operator.png'
      } else {
        return 'logo-226.svg'
      }
    },
    items () {
      if (this.loggedIn && this.hasAnyAds) {
        if (this.isMerchant) {
          return this.getItems('account-merchant-ads', true)
        } else {
          return this.getItems('account-my-vehicles')
        }
      }

      if (this.isMerchant) {
        return this.getItems('sell', true)
      } else {
        return this.getItems('sell')
      }
    },
    loggedIn () {
      return this.$auth.loggedIn
    }

  },

  methods: {
    getItems (link, running = false) {
      return [
        {
          link: 'catalog',
          name: 'catalog',
          query: running
            ? {
                auction_status: 'running'
              }
            : {}
        },
        {
          link,
          name: 'sell'
        },
        {
          link: 'blog',
          name: 'blog'
        },
        {
          link: 'contact',
          name: 'contact'
        }
      ]
    },

    getLocalPath (item) {
      if (item.query) {
        return this.localePath({ name: item.link, query: item.query })
      } else {
        return this.localePath(item.link)
      }
    },

    async login () {
      const route = {
        path: this.$route.path
      }

      await utils.addRedirectActionAndLogin(this, 'login', route)
    },
    async signup () {
      // const route = {
      //   name: this.$route.path
      // }

      await utils.addRedirectActionAndLogin(this, 'signUp')
    }

  }
}

